import { Component } from '@angular/core';
import { ORCIDQualificationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Qualifications') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidqualification-form',
    templateUrl: './orcidqualification.form.component.html'
})
export class ORCIDQualificationFormComponent extends BaseFormComponent {
    public record!: ORCIDQualificationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

